import qs from 'querystring';

import axios from 'axios';
import getConfig from 'next/config';

import { isServer } from './isServer';

const makeEndpoint = (url: string): string => {
  const { webPath } = getConfig().publicRuntimeConfig;
  if (isServer && url.startsWith('/')) {
    return `${webPath}${url}`;
  }

  return url;
};

const instance = axios.create({
  timeout: 5000,
  responseType: 'json',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

instance.interceptors.request.use((config) => {
  config.paramsSerializer = qs.stringify;
  config.url = makeEndpoint(config.url);

  return config;
});

export default instance;
